import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { EventEmitter } from '@flipster/utils/event-emitter';

import type { SocketState } from '../../AbstractSocket';
import type AbstractSocket from '../../AbstractSocket';
import type { V2SocketEvents, WsV2Message } from '../types';
import type { WsV2Events } from './../types';
import { R230522Scope } from './context';

// 소켓 구독을 트리거 하고싶지는 않지만 이벤트는 감지하고 싶을 때 사용
export const weakR230522SocketBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);

  const r230522Socket = bunja.use(R230522Scope);
  const r230522Events = new EventEmitter<WsV2Events>();

  const socketStateAtom = atom<SocketState>(r230522Socket.state);
  socketStateAtom.debugLabel = `${r230522Socket.debugLabel} - state`;

  const isConnectedAtom = atom<boolean>((get) => get(socketStateAtom) === 'connected');
  isConnectedAtom.debugLabel = `${r230522Socket.debugLabel} - isConnected`;

  function setSocketState(state: SocketState) {
    store.set(socketStateAtom, state);
  }

  function messageHandler(this: AbstractSocket<unknown, V2SocketEvents>, message: unknown) {
    const { p: timestamp, s: symbol, t, e } = message as WsV2Message;
    if (t) {
      this.emit('r230522table', t);
      for (const [tableTopic, data] of Object.entries(t)) {
        this.emit(tableTopic as keyof V2SocketEvents, { data, symbol, timestamp });
      }
    }
    if (e) {
      this.emit('r230522event', e);
      for (const [eventTopic, event] of Object.entries(e)) {
        r230522Events.emit(eventTopic as keyof WsV2Events, event);
      }
    }
  }

  bunja.effect(() => {
    r230522Socket.on('stateChanged', setSocketState);
    r230522Socket.on('message', messageHandler);
    return () => {
      r230522Socket.off('stateChanged', setSocketState);
      r230522Socket.off('message', messageHandler);
    };
  });

  return { r230522Socket, r230522Events, socketStateAtom, isConnectedAtom };
});
weakR230522SocketBunja.debugLabel = 'weakR230522SocketBunja';
